import { Injectable } from "@angular/core";
import { SessionInfoSingleton } from "../data/singleton/session-info.singleton";
import { AuthService } from "./auth/auth.service";
import { AlertMessage } from "../constants/messages/alert-message";
import { Const } from "../data/models/const";

/**
 * セッション管理のサービスクラス
 */
@Injectable({
  providedIn: "root",
})
export class SessionService {
  private readonly SESSION_TIMEOUT_MINUTES = 30; // セッションタイムアウトまでの時間（分）

  /**
   * コンストラクタ
   * @param authService
   * @param sessionInfoSingleton
   */
  constructor(
    private authService: AuthService,
    private sessionInfoSingleton: SessionInfoSingleton,
  ) {}

  /**
   * セッションのチェック処理
   * - 最終操作からのタイムアウト時間が経過しているか
   * - トークンの再取得で、取得できなかったか
   * @returns チェック結果:Promise<Boolean>
   */
  async checkSession(): Promise<Boolean> {
    // ネットワークチェック
    if (!navigator.onLine) {
      alert(AlertMessage.NET_ERROR_MESSAGE);
      console.error("ネットワークエラー");
      return false;
    }

    // 最終操作のチェック
    if (
      Date.now() >=
      this.sessionInfoSingleton.getLastOperationDatetime() +
        this.SESSION_TIMEOUT_MINUTES * 60 * 1000
    ) {
      console.error("最終操作のタイムアウト");
      alert(AlertMessage.SESSION_BREAK_MESSAGE);
      this.logout();
      return false;
    }

    // 最終操作の更新
    this.sessionInfoSingleton.updateLastOperationDatetime();

    // IDトークンの取得
    const token = await new Promise<any>((resolve,reject)=>{
      this.authService.getIdToken().subscribe({
        next: (response: any) => resolve(response),
        error: (err: any) => reject(err)
      })
    })
    if (token) {
      this.sessionInfoSingleton.setIdToken(token);
      console.log("SessionService:", "トークン取得時刻：" + Date());
      return true;
    } else {
      // idトークンがnullの場合はログイン画面へ遷移
      console.error("トークンの期限切れ");
      alert(AlertMessage.SESSION_BREAK_MESSAGE);
      this.logout();
      return false;
    }
  }

  /** PRIVATE */
  /**
   * ログアウト処理
   * - ログイン後の情報を解放し、ログアウトする。
   */
  private logout() {
    Const.release();
    this.authService.signOut();
  }
}
